import { ArrayFieldItemTemplateType } from '@rjsf/utils';
import { ChevronDown, ChevronUp, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ArrayFieldItemTemplate(props: ArrayFieldItemTemplateType) {
  const { t } = useTranslation('storefront');
  const { children, index, hasToolbar, buttonsProps } = props;
  const { disabled, readonly, hasMoveUp, hasMoveDown, hasRemove, onReorderClick, onDropIndexClick } =
    buttonsProps;

  return (
    <div
      className="border-border bg-card hover:border-primary/30 relative mb-3 rounded-lg border-2 p-4 shadow-md transition-all hover:shadow-lg"
      style={{
        // Hide any legend elements inside array items (e.g., "Product Benefits-1")
        ['--hide-item-legend' as any]: 'none',
      }}
    >
      {/* Badge number - small but contrasted */}
      <div className="bg-primary text-primary-foreground absolute -left-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full text-[9px] font-bold shadow-md">
        {index + 1}
      </div>

      {/* Action buttons - top right */}
      {hasToolbar && (
        <div className="absolute -right-2 -top-2 flex gap-1">
          {hasMoveUp && (
            <button
              type="button"
              onClick={onReorderClick(index, index - 1)}
              disabled={disabled || readonly}
              className="bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary flex h-7 w-7 items-center justify-center rounded-full border-2 shadow-md transition-all disabled:opacity-50"
              title={t('configEditor.arrayField.moveUp')}
            >
              <ChevronUp className="h-3.5 w-3.5" />
            </button>
          )}
          {hasMoveDown && (
            <button
              type="button"
              onClick={onReorderClick(index, index + 1)}
              disabled={disabled || readonly}
              className="bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary flex h-7 w-7 items-center justify-center rounded-full border-2 shadow-md transition-all disabled:opacity-50"
              title={t('configEditor.arrayField.moveDown')}
            >
              <ChevronDown className="h-3.5 w-3.5" />
            </button>
          )}
          {hasRemove && (
            <button
              type="button"
              onClick={onDropIndexClick(index)}
              disabled={disabled || readonly}
              className="bg-card text-destructive hover:bg-destructive hover:border-destructive hover:text-destructive-foreground border-border flex h-7 w-7 items-center justify-center rounded-full border-2 shadow-md transition-all disabled:opacity-50"
              title={t('configEditor.arrayField.remove')}
            >
              <X className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      )}

      {/* Content wrapper - hides the item legend */}
      <div className="[&_fieldset>legend]:hidden [&_legend]:first:hidden">{children}</div>
    </div>
  );
}
